import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Button } from "../ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "../ui/alert-dialog";
import { api, errMsg } from "../../lib/api";

export const PpcSend = ({ d, onChanged, membersVer }) => {
  const [count, setCount] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/ppc/members").then((r) => setCount(r.data.length)).catch(() => setCount(0)); }, [membersVer]);
  const last = (d.sends || []).slice(-1)[0];
  const send = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/analyst/ppc-drafts/${d.draft_id}/send`);
      toast.success(`Sent to ${r.data.sent} PPC member${r.data.sent === 1 ? "" : "s"}`);
      if (r.data.failed) toast.error(`Could not reach: ${r.data.failed_names.join(", ")}`);
      onChanged();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="ppc-send">
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button disabled={busy || !count} className="bg-amber-900 hover:bg-[#5B210B]" data-testid="ppc-send-button"><Send className="h-4 w-4 mr-1" />{busy ? "Sending…" : "Email to PPC members"}</Button>
        </AlertDialogTrigger>
        <AlertDialogContent className="bg-white">
          <AlertDialogHeader><AlertDialogTitle>Send this approved summary?</AlertDialogTitle><AlertDialogDescription>It will be emailed to {count} PPC member{count === 1 ? "" : "s"} on the PPC email list.{last ? " It has already been sent before." : ""}</AlertDialogDescription></AlertDialogHeader>
          <AlertDialogFooter><AlertDialogCancel>Cancel</AlertDialogCancel><AlertDialogAction onClick={send} data-testid="ppc-send-confirm">Send now</AlertDialogAction></AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <span className="text-xs text-stone-500" data-testid="ppc-send-info">
        {count === 0 ? "Add members to the PPC email list first." : last ? `Last sent ${new Date(last.at).toLocaleString()} by ${last.by} to ${last.sent} member${last.sent === 1 ? "" : "s"}` : "Not sent yet"}
      </span>
    </div>
  );
};
